var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils, CustomElement, Watch, P, PropertyConverters, PropertyChangeEvent, PacemEventTarget } from '@pacem/pacem-core';
import { LatLngConverter } from './types-components';
;
const consts = {
    GEOLOCATION_UNAVAILABLE: 'geolocation_unavailable',
    POSITION_UNAVAILABLE: 'position_unavailable',
    PERMISSION_DENIED: 'permission_denied',
    TIMEOUT: 'timeout',
    UNKNOWN_ERROR: 'unknown_error',
};
let PacemMapGeolocateElement = class PacemMapGeolocateElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.permission = 'prompt';
        this.maximumAge = 15000;
        this.timeout = 30000;
        this.#fetching = false;
        this._successCallback = (position) => {
            this.permission = 'granted';
            this._setFetching(false);
            const detail = {
                lat: position.coords.latitude, lng: position.coords.longitude,
                timestamp: position.timestamp, altitude: position.coords.altitude,
                heading: position.coords.heading, speed: position.coords.speed
            };
            this.position = detail;
            this.dispatchEvent(new CustomEvent('success', { detail }));
        };
        this._errorCallback = (err) => {
            this._setFetching(false);
            const detail = typeof err === 'string' ? err : this._errToString(err);
            this.dispatchEvent(new CustomEvent('error', { detail }));
        };
    }
    _checkPermission() {
        return new Promise(resolve => {
            const permissionApi = navigator.permissions;
            if (Utils.isNull(permissionApi)) {
                resolve('prompt');
            }
            else {
                permissionApi.query({ name: 'geolocation' }).then(p => {
                    resolve(this.permission = p.state);
                });
            }
        });
    }
    #fetching;
    get fetching() {
        return this.#fetching;
    }
    _setFetching(val) {
        if (val !== this.fetching) {
            this.#fetching = val;
            this.dispatchEvent(new PropertyChangeEvent({ propertyName: 'fetching', currentValue: val, oldValue: !val }));
        }
    }
    fetch() {
        if (this.disabled) {
            return;
        }
        if (!navigator.geolocation) {
            this._errorCallback(consts.GEOLOCATION_UNAVAILABLE);
            return;
        }
        this._checkPermission().then(_ => {
            this._setFetching(true);
            navigator.geolocation.getCurrentPosition(this._successCallback, this._errorCallback, { enableHighAccuracy: true, maximumAge: this.maximumAge });
        });
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._checkPermission();
    }
    _errToString(err) {
        switch (err.code) {
            case GeolocationPositionError.PERMISSION_DENIED:
                return consts.PERMISSION_DENIED;
            case GeolocationPositionError.POSITION_UNAVAILABLE:
                return consts.POSITION_UNAVAILABLE;
            case GeolocationPositionError.TIMEOUT:
                return consts.TIMEOUT;
            default:
                return consts.UNKNOWN_ERROR;
        }
    }
};
__decorate([
    Watch({ emit: true, converter: LatLngConverter })
], PacemMapGeolocateElement.prototype, "position", void 0);
__decorate([
    Watch({ emit: true, converter: PropertyConverters.String })
], PacemMapGeolocateElement.prototype, "permission", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapGeolocateElement.prototype, "maximumAge", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemMapGeolocateElement.prototype, "timeout", void 0);
PacemMapGeolocateElement = __decorate([
    CustomElement({ tagName: P + '-map-geolocate' })
], PacemMapGeolocateElement);
export { PacemMapGeolocateElement };
